import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EllipsisVertical } from "@air/next-icons";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import { IconButton } from "@air/primitive-icon-button";
import { useMemo } from "react";
import { SharePrivateContentLinkFooter } from "~/components/SharePrivateContentModal/SharePrivateContentLinkFooter";
import { PRIVATE_SHARE_LINK } from "~/constants/testIDs";
import { NEW_TAB } from "~/constants/urls";
export const SharePrivateContentLink = (param)=>{
    let { createdAt, createdBy, shareUrl, menuActions = [] } = param;
    const actionsToShow = useMemo(()=>{
        const actions = [
            {
                id: "preview",
                label: "Preview",
                onSelect: ()=>window.open(shareUrl, NEW_TAB),
                type: "item"
            }
        ];
        actions.push(...menuActions);
        return actions;
    }, [
        menuActions,
        shareUrl
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex h-12 flex-auto items-center justify-between rounded border border-solid border-grey-5 bg-grey-3 px-3",
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "select-all truncate text-16 text-grey-12",
                "data-testid": PRIVATE_SHARE_LINK,
                children: shareUrl
            }),
            menuActions && /*#__PURE__*/ _jsxs(DropdownMenu, {
                trigger: /*#__PURE__*/ _jsx(IconButton, {
                    className: "-mr-0.5",
                    icon: EllipsisVertical,
                    color: "grey",
                    appearance: "ghost",
                    label: "Open menu"
                }),
                children: [
                    renderDropdownItems({
                        options: actionsToShow
                    }),
                    !!createdAt && !!createdBy && /*#__PURE__*/ _jsx(SharePrivateContentLinkFooter, {
                        createdAt: createdAt,
                        createdBy: createdBy
                    })
                ]
            })
        ]
    });
};
